module.exports = __webpack_public_path__ + "img/basketball.91151602.svg";